export default "__VITE_ASSET__B0Buy5aD__"